"use client";

import React, { useState, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, Sparkles, Download } from "lucide-react";
import { cn } from "@/lib/utils";
const portfolioItems = [{
  id: 1,
  niche: "Medium Business",
  title: "Dinstar SBC1000",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc1000.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc1000.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc1000.png-wvc-sizes",
  description: "SBC de alto rendimiento para medianas empresas. Soporta hasta 500 sesiones simultáneas y transcodificación avanzada.",
  className: "md:col-span-2 md:row-span-2 min-h-[300px] md:min-h-[600px]"
}, {
  id: 2,
  niche: "Small Office",
  title: "Dinstar SBC300",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc300.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc300.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc300.png-wvc-sizes",
  description: "Solución compacta y potente para pequeñas oficinas. Hasta 50 sesiones simultáneas con seguridad empresarial completa.",
  className: "md:col-span-1 md:row-span-2 min-h-[300px] md:min-h-[600px]"
}, {
  id: 3,
  niche: "Enterprise",
  title: "Dinstar SBC3000",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc3000.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc3000.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc3000.png-wvc-sizes",
  description: "Diseñado para grandes corporativos. Soporta hasta 2000 sesiones simultáneas con alta disponibilidad y redundancia.",
  className: "md:col-span-1 md:row-span-2 min-h-[300px] md:min-h-[600px]"
}, {
  id: 4,
  niche: "Carrier Grade",
  title: "Dinstar SBC8000",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc8000.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc8000.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/dinstar_sbc8000.png-wvc-sizes",
  description: "Basado en Software, para ambientes virtuales on-premise o cloud.\xA0",
  className: "md:col-span-4 md:row-span-1 min-h-[250px]"
}];
function TiltCard({
  item,
  index
}: {
  item: typeof portfolioItems[0];
  index: number;
}) {
  const [style, setStyle] = useState<React.CSSProperties>({});
  const cardRef = useRef<HTMLDivElement>(null);
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const rotateX = (y - centerY) / centerY * -5;
    const rotateY = (x - centerX) / centerX * 5;
    setStyle({
      transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
      transition: "none"
    });
  };
  const handleMouseLeave = () => {
    setStyle({
      transform: `perspective(1000px) rotateX(0deg) rotateY(0deg)`,
      transition: "transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)"
    });
  };
  return <div data-index={index} ref={cardRef} className={cn("group relative overflow-hidden rounded-md bg-accent cursor-pointer isolate shadow-md", item.className)} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} style={style}>
      <div className="absolute inset-0 z-0">
        <img src={item.img} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={`Modelo Dinstar ${item.title}`} loading="lazy" decoding="async" className="h-full w-full object-cover transition-all duration-700 ease-out group-hover:scale-105" />
      </div>

      <div className="absolute inset-0 z-10 bg-primary/20 opacity-100 transition-opacity duration-500 group-hover:opacity-0" />

      <div className="absolute inset-0 z-20 flex flex-col justify-between p-6 md:p-8 opacity-100 transition-all duration-500 translate-y-0">
        <div className="flex justify-end">
          <Badge variant="secondary" className="bg-secondary text-secondary-foreground shadow-sm px-3 py-1.5 text-sm font-medium tracking-wide rounded-md">
            {item.niche}
          </Badge>
        </div>
        
        <div className="transform transition-transform duration-500 bg-white/90 backdrop-blur-sm p-4 rounded-md shadow-sm">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-foreground mb-2 tracking-tight">
            {item.title}
          </h3>
          <p className="font-default text-sm md:text-base max-w-xs text-muted-foreground">
            {item.description}
          </p>
          <div className="mt-4 text-secondary font-semibold text-sm flex items-center gap-1">
            Ver Detalles <ArrowRight className="size-3" />
          </div>
        </div>
      </div>
    </div>;
}
export default function ModelosDeSbcDinstar() {
  return <section data-section-id="224593" id="modelos-de-sbc-dinstar" className="w-full py-14 md:py-16 bg-accent overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-[1280px]">
        
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-8 md:mb-10">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 text-primary mb-6">
              <Sparkles className="size-4" />
              <span className="text-sm font-semibold tracking-wide uppercase">Hardware VoIP</span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tight mb-6">
              Modelos de SBC Dinstar
            </h2>
            <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed">
              Descubra nuestra gama de Session Border Controllers optimizados. Soluciones potentes para oficinas pequeñas y medianas empresas con seguridad de voz garantizada.
            </p>
          </div>
          
          <div className="shrink-0">
            <Link to="#">
              <Button size="lg" className="rounded-md px-8 bg-secondary hover:bg-secondary/90 text-secondary-foreground shadow-md">
                Solicitar Cotización
                <ArrowRight className="ml-2 size-4" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {portfolioItems.map((item, i) => <TiltCard key={item.id} item={item} index={i} />)}
        </div>

        <div className="mt-8 md:mt-10 flex justify-center">
          <Link to="#" target="_blank" download="Porqué_necesitas_un_SBC.pdf" className="w-full">
            
          </Link>
        </div>

      </div>
    </section>;
}